import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    isRequesting: false,
    error: null,
    data: {},
    total: 0,
    searchCriteria: {},
};
const slice = createSlice({
    name: 'businessPlan',
    initialState: initialState,
    reducers: {
        get_list: (state, action) => {
            return {
                ...state,
                isRequesting: true,
                error: null,
                searchCriteria: { ...action.payload },
            };
        },
        get_list_succeed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: null,
                data: action.payload,
            };
        },
        get_list_failed: (state, action) => {
            return {
                ...state,
                isRequesting: false,
                error: action.payload.error,
                data: [],
                total: 0,
            };
        },

        update_business_plan: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        import_file: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },

        import_file_success: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
        update_business_plan_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },

        delete_business_plan: (state) => {
            return {
                ...state,
                isRequesting: true,
            };
        },
        delete_business_plan_succeed: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },

        reset_state: () => {
            return initialState;
        },
        fail: (state) => {
            return {
                ...state,
                isRequesting: false,
            };
        },
    },
});

export const { reducer, actions } = slice;

export default reducer;
